import { DatePicker } from 'antd';
import { Moment } from 'moment';
import React from 'react';
import './style.scss';
const { RangePicker } = DatePicker;
interface IProps {
    value?: Moment;
    defaultValue?: Moment;
    placeholder?: string;
    className?: string;
    disabled?: boolean;
    disabledTime?: (_: any, value: any) => void;
    disabledDate?: (value: any) => void;
    height?: number;
    onOk?: (date: Moment) => void;
    format?: string;
    suffixIcon?: boolean;
    picker?: 'date' | 'month' | 'quarter' | 'year' | 'time';
    field?: any;
    width?: number;
    showTime?: boolean;
    onChange?: (value: any) => void;
    allowEmpty?: [boolean, boolean];
}

const RangePickerWrap: React.FC<IProps> = ({
    onChange,
    placeholder,
    disabled,
    disabledTime,
    disabledDate,
    value,
    onOk,
    format,
    suffixIcon = false,
    defaultValue,
    picker = 'date',
    field,
    width,
    showTime,
    allowEmpty,
}) => {
    const props = {
        disabled,
        disabledTime,
        disabledDate,
        placeholder,
        onChange,
        value,
        onOk,
        format,
        defaultValue,
        showTime,
        allowEmpty,
        ...(!suffixIcon && { suffixIcon: null }),
    };

    return (
        <RangePicker
            style={{ width }}
            className={`rangepicker__wrap`}
            picker={picker}
            {...props}
            {...field}
            showTime={showTime}
            disabledTime={disabledTime}
            disabledDate={disabledDate}
            allowEmpty={allowEmpty}
        />
    );
};

export default React.memo(RangePickerWrap);
